<template>
  <div>
    <el-dialog class="rebuttalDsiplayDialog" :visible.sync="rebuttalDisplayModal" width="40%" :before-close="handleClose" :destroy-on-close="true">
      <span slot="title"> Rebuttal Responses for Patient Number {{ record.patientNumber }} </span>
      <div v-for="(rebuttal, index) in record.rebuttals" :key="rebuttal.rebuttalId">
        <h5 class="headerWithBorderDark responseSectionCoder">
          <div v-if="rebuttal.rebuttalId" :id="index" style="display: flex; align-items: center; justify-content: right;">
            <i class="mdi mdi-account" style="color: rgb(79, 27, 168); font-size: 16px; margin: 0px 5px 0px 5px;"></i>
            <span>
              {{ rebuttal.recipientContactName }} on
              <i
                ><small>{{ formatDate(rebuttal.rebuttalDate) }}</small></i
              >
            </span>
          </div>
        </h5>
        <div class="coderResponse">
          <div>
            <div v-if="calcNoChangeAddValidation()" style="padding: 10px; display: flex; justify-content: center; align-items: center;">
              <div>
                <i class="el-icon-success" style="color: #7cbe5f; font-size: 20px; margin: 0px 5px 0px 0px;"></i>
              </div>
              <div style="color: #48576a; font-size: 13px; font-weight: bold; " class="">
                Record has no recommendations, response is not required, but you may still enter a comment below
              </div>
            </div>
            <div v-if="rebuttal.rebuttalId">
              <div style="margin-left: 10px; word-break: break-word;">
                <el-form ref="form" id="form" label-position="left" label-width="150px" size="mini" style="margin-top: 0px;">
                  <template v-if="index >= 0">
                    <el-form-item v-if="!calcNoChangeAddValidation()" label="Recipient Agrees with Findings">
                      <el-col style="margin-top: 3px;">
                        <input :disabled="true" type="radio" name="codes" :value="true" v-model="rebuttal.agreeWithCodes" />
                        Yes
                        <input :disabled="true" type="radio" name="codes" :value="false" v-model="rebuttal.agreeWithCodes" />
                        No
                      </el-col>
                    </el-form-item>
                    <el-form-item label="Auditor Response Required">
                      <el-col style="margin-top: 3px;">
                        <input :disabled="true" type="radio" name="auditor" :value="true" v-model="rebuttal.responseRequired" />
                        Yes
                        <input :disabled="true" type="radio" name="auditor" :value="false" v-model="rebuttal.responseRequired" /> No
                      </el-col>
                    </el-form-item>
                  </template>

                  <template v-if="rebuttal.rebuttalId">
                    <label class="el-form-item__label" style="width: 100%; margin-bottom: 10px;">Response Documentation</label>
                    <div>
                      <HiaRichText :editable="false" v-model="rebuttal.rebuttalDocumentation" containerName="particleblobs"> </HiaRichText>
                    </div>
                  </template>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <template v-if="rebuttal.rebuttalId">
          <h5 class="headerWithBorderDark responseSectionAuditor">
            <template v-if="rebuttal.responseDate">
              <div style="display: flex; align-items: center;">
                <i class="mdi mdi-account" style="color: rgb(79, 27, 168); font-size: 16px; margin-right: 7px;"></i>
                <span>
                  {{ rebuttal.consultantName }} on
                  <i
                    ><small>{{ formatDate(rebuttal.responseDate) }}</small></i
                  >
                </span>
              </div>
            </template>
          </h5>
          <div class="auditorResponse">
            <div style="padding: 10px;">
              <el-form ref="form" id="form" label-position="left" label-width="150px" size="mini" :key="1" style="margin-top: 0px;">
                <div style="margin: 5px 0px 10px 0px; display: flex; justify-content: center; align-items: center;">
                  <div>
                    <i v-if="rebuttal.rebuttalStatus === 'Auditor Response Completed' || rebuttal.rebuttalStatus === 'Auditor Response Not Required'" class="el-icon-success" style="color: #7cbe5f; font-size: 17px; margin: 0px 5px 0px 5px;"></i>

                    <i v-else class="mdi mdi-timer-sand" style="color: #87CEEB; font-size: 20px; font-weight: bold; margin: 0px 5px 0px 5px;"></i>
                  </div>
                  <div key="no change" style="color: #48576a; font-size: 13px; font-weight: bold; ">
                    {{ rebuttal.rebuttalStatus }}
                  </div>
                </div>

                <template v-if="rebuttal.responseDate && (rebuttal.rebuttalStatus === 'Auditor Response Completed' || rebuttal.rebuttalStatus === 'Auditor Response Not Required')">
                  <el-form-item label="Auditor Findings Determination">
                    <div style="margin: 6px 0 0 15px;">{{ rebuttal.agreeWithCodes ? 'N/A' : rebuttal.codesStatusCalc }}</div>
                  </el-form-item>

                  <label class="el-form-item__label" style="width: 100%; margin-bottom: 10px;">Auditor Response Description</label>
                  <HiaRichText :editable="false" v-model="rebuttal.responseDescription" containerName="particleblobs"> </HiaRichText>
                </template>
              </el-form>
            </div>
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dateHelper from '@/mixins/date-helper'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import HiaRichText from '@/components/HiaRichText'
export default {
  name: 'rebuttalDisplay',
  props: ['record', 'rebuttalDisplayModal'],
  mixins: [HiaAuthorization, dateHelper],
  data: function() {
    return {}
  },
  components: {
    HiaRichText
  },
  methods: {
    handleClose() {
      //   this.rebuttalDisplayModal = false
      this.$emit('close')
    },
    calcNoChangeAddValidation() {
      if (this.record.reasonForChange === 0 && this.record.rebuttals.length === 0) {
        return true
      }
      if (this.record.rebuttals.length > 0 && this.record.rebuttals[0].reasonForChange === 0) {
        return true
      }
      return false
    }
  },
  computed: {}
}
</script>
<style scoped>
.coderResponse {
  background-color: rgb(232 235 249);
  /* background-color: rgb(243 242 241); */
  border-radius: 5px;
  margin-right: 15px;
  margin-left: 10%;
  padding: 10px;
}

.auditorResponse {
  background-color: #ffffff;
  padding: 10px;
  border-radius: 5px;
  margin-right: 10%;
  margin-left: 15px;
  margin-bottom: 25px;
}

.responseSectionCoder {
  text-align: right;
}

.responseSectionAuditor {
  margin-top: 20px;
}

>>> .rich-text {
  overflow-y: auto !important;
  max-height: 150px !important;
}

.richText img {
  width: 100%;
  /* or any custom size */
  height: 100%;
  object-fit: contain;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  height: 0px;
}

>>> .tox-tinymce {
  border-radius: 5px;
}

.textField {
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  margin: 10px 10px 20px 0px;
  min-height: 30px;
  font-size: 14px;
  overflow-x: auto;
  white-space: pre-line;
}

>>> .rebuttalDsiplayDialog > .el-dialog {
  margin-top: 2vh !important;
}

>>> .el-input--mini .el-input__inner {
  height: 22px !important;
  line-height: 22px !important;
}

>>> .el-form--label-top .el-input--mini {
  margin-top: 8px;
}

>>> .el-form-item--mini.el-form-item,
>>> .el-form-item--small.el-form-item {
  margin-bottom: 8px !important;
}

>>> .el-form-item--mini .el-form-item__content,
>>> .el-form-item--mini .el-form-item__label {
  line-height: 1 !important;
}

>>> .el-input--mini .el-input__icon {
  line-height: 22px !important;
}

>>> div.el-input--mini > input[style*='height: 28px;'] {
  height: 22px !important;
}

>>> .el-form-item__label {
  vertical-align: middle !important;
  float: left !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #48576a !important;
  line-height: 1 !important;
  padding: 6px 0 0 !important;
  box-sizing: border-box !important;
}
</style>
